// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3MbtZ","file":"styles_file__1zs9c"};